import { ControlType, FormFieldBase } from './form-field-base.model';

export class DateFormField extends FormFieldBase<Date> {
  controlType: ControlType = 'datepicker';
}
